<div class="block">
  <!-- <div class="scan-qr">
    <div class="square">
      <ion-icon name="scan" (click)="startScanner()"></ion-icon>
    </div>
  </div> -->
  <form (ngSubmit)="f.valid && addUserDetails()" #f="ngForm">
    <ion-item fill="outline" mode="md" class="mob-item">
      <ion-input class="mob" #inputinfo placeholder="{{'enterMobilenumber' | language : 'Enter Mobile Number'}}"
        inputmode="tel" value="" type="text" minlength="10" class="inputField" maxlength="10"
        (ionInput)="isNumberKey($event)" (ionChange)="validatePhone($event)" [(ngModel)]="phoneNumber"
        [ngModelOptions]="{standalone: true}"></ion-input>
      <ion-icon class="mic" name="mic" size="large" (click)="startVoiceRecognition()"></ion-icon>
    </ion-item>
    <div class="details-success-msg" *ngIf="showSuccessMessage">
      <span>{{'CustomerDetailsFetchedSuccessfully' | language : 'Customer Details Fetched Successfully'}}</span>
      <img src="assets/images/eva_person.png" />
    </div>
  </form>
  <ion-button expand="block" mode="ios" class="guest" (click)="loginGuest()" [disabled]="commonService.isLoading">
    <ng-container *ngIf="!commonService.isLoading">
      <ion-icon name="person" slot="start"></ion-icon>
      <ion-label>{{'continueasguest' | language : 'Continue As Guest'}}</ion-label>
    </ng-container>
  </ion-button>
</div>